import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PolService } from '../ctb-pol.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
import {PaginadorService, PageBusquedaObject} from '../../../paginador/paginador.service';
import { AddDocService } from './../../add-doc/add-doc.service';
import { ListaNegraService } from './../../add-doc/lista-negra.service';
import { PeriodoEjercicioService } from '../../../control/periodo.service';
@Component({
  selector: 'catalogo-ctb-pol',
  templateUrl: './catalogo-ctb-pol.component.html',
  styleUrls: ['./catalogo-ctb-pol.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [PolService,AddDocService,ListaNegraService],
  preserveWhitespaces: true
}) 
export class CatalogoCtbPolComponent implements OnInit {

  public id: string | null = null;
  public folio: string | null = null;
  public fecha: string | null = null;
  public inicio: string | null = null;
  public fin: string | null = null;
  public concepto: string | null = null;

  public ctb_pol_conf: any[] = [];
  @Input() PermitirSoloAsociar: boolean = false;
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;

  totalItemsAddDoc: number;
  fecha_poliza = '';
  _ctb_tpol_id: number = 0;
  _ctb_pol_id: number = 0;
  public tpolList: any[] = [];
  items: any[];
  tipo_cierre: number;
  folio_inicial: String='';
  folio_final: String='';
  tmp_index_pol: number;
  cargado: boolean;
  filtro_navegacion: boolean;
  periodo_vigente: number = 0;
  ejercicio_seleccionado: number;
  titulo_paginador = 'pol-paginador';
  consulta_lista_negra: any = { campos: [], lista: [] };
  selectedYear: number;
  selectedMonth: number;
  selectedDay: number;
  elemento: any = { nombre: '', contenido: '' };
  campos: any = [{ nombre: 'uuid', checked: true },
  { nombre: 'serie', checked: true },
  { nombre: 'folio', checked: true },
  { nombre: 'tipo', checked: true },
  { nombre: 'tipo_cfdi', checked: true },
  { nombre: 'fecha_emision', checked: true },
  { nombre: 'rfc_emisor', checked: true },
  { nombre: 'emisor', checked: false },
  { nombre: 'rfc_receptor', checked: true },
  { nombre: 'receptor', checked: false }];
  years: number[] = [];
  busquedaAddDoc: any = {};
  itemsAddDoc: any[];
  documentos_asociados: [] = [];
 months: string[] = [
  'Todos',
  'Periodo 1 - Enero',
  'Periodo 2 - Febrero',
  'Periodo 3 - Marzo',
  'Periodo 4 - Abril',
  'Periodo 5 - Mayo',
  'Periodo 6 - Junio',
  'Periodo 7 - Julio',
  'Periodo 8 - Agosto',
  'Periodo 9 - Septiembre',
  'Periodo 10 - Octubre',
  'Periodo 11 - Noviembre',
  'Periodo 12 - Diciembre',
  'Periodo 13 - Ajuste'
];
  days: number[] = [];
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(
    private listaNegraService: ListaNegraService,
    private addDocService: AddDocService,private paginadorService:PaginadorService,public loginService: LoginService, private router: Router, private polService: PolService, private route: ActivatedRoute, private PeriodoEjercicioService: PeriodoEjercicioService) {
  }


  validarInputPeriodoCerrado(): boolean {

  const fecha = this.fecha_poliza.split('-');

  const anio = parseInt(fecha[0], 10);
  const mes = parseInt(fecha[1], 10);
  const dia = parseInt(fecha[2], 10);

  // Cierre ejercicio (periodo 13)
  if (
    this.periodo_vigente === 13 &&
    this.ejercicio_seleccionado === anio &&
    mes === 12 &&
    dia === 31
  ) {

    return false;


  }

  // Cierre por periodo
  if (this.tipo_cierre === 2) {

    return this.periodo_vigente !== mes ||
      this.ejercicio_seleccionado !== anio;


  }

  // Cierre ejercicio
  if (this.tipo_cierre === 1) {

    return this.ejercicio_seleccionado !== anio;


  }

  
    return false;

}
  inicializarBusqueda() {
    this.busquedaAddDoc.criteriaSearch = {};
    
    this.busquedaAddDoc.criteriaSearch['tipoCfdi'] = 0;
    this.busquedaAddDoc.itemsPerPage = 5;
    this.busquedaAddDoc.pageNumber = 0;
  }
  catalogoAddDoc() {
    this.busquedaAddDoc.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.addDocService.catalogo(this.busquedaAddDoc).subscribe(
      response => {
        this.itemsAddDoc = response.contenido.content;
        for (let x = 0; x < this.itemsAddDoc.length; x++) {
          this.itemsAddDoc[x].estatus_verificado = 1;
        }
        this.totalItemsAddDoc = response.contenido.totalElements;
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  borrarPolizaIntervalo(){

    Swal.fire({
      title: 'Atención',
      text: '¿Está seguro de dar de baja las polizas desde el folio ' + this.folio_inicial + ' hasta el folio ' + this.folio_final + '?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        
      }
    });

  }
  cambiarPaginaAddDoc(event: any): void {
    this.busquedaAddDoc.pageNumber = event.page - 1;
    this.catalogoAddDoc();
  }
  filtroDeBusquedaAddDoc(find: any, columnName: any): void {
    this.busquedaAddDoc.criteriaSearch[columnName] = find;
  }
  sortearPorAddDoc(columnName: any): void {
    this.busquedaAddDoc.column = columnName;
    this.busquedaAddDoc.sort = true;
    this.busquedaAddDoc.pageNumber = 0;
    switch (this.busquedaAddDoc.order) {
      case 'desc':
        this.busquedaAddDoc.order = 'asc';
        break;
      default:
        this.busquedaAddDoc.order = 'desc';
        break;
    }
    this.catalogoAddDoc();
  }
  buscarEnCatalogoAddDoc(): void {
    this.busquedaAddDoc.itemsPerPage = 5;
    this.busquedaAddDoc.pageNumber = 0;
    if (this.busquedaAddDoc.criteriaSearch['fecha'] != null) {
      this.busquedaAddDoc.column = 'fecha';
      this.busquedaAddDoc.sort = true;
      this.busquedaAddDoc.pageNumber = 0;
      this.busquedaAddDoc.order = 'asc';
    }
    this.catalogoAddDoc();
  }
  limpiarBusquedaAddDoc(): void {
    setTimeout(() => {
      this.busquedaAddDoc.criteriaSearch = {};
      this.busquedaAddDoc.criteriaSearch['tipoCfdi'] = 0;
      this.busquedaAddDoc.criteriaSearch['asociado'] = 0;
      this.buscarEnCatalogoAddDoc();
    },
      50);
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {

    
this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
  this.ejercicio_seleccionado = ejercicio?ejercicio:0;

});
this.PeriodoEjercicioService.periodo$
.subscribe(periodo => {

  this.periodo_vigente = periodo?periodo:0;
});
    
    this.route.queryParams.subscribe(params => {
      
      this.folio = params['folio'] || null;
      this.id = params['id'] || null;
      this.fecha = params['fecha'] || null;
      this.concepto = params['concepto'] || null;

      // Aquí puedes inicializar tu formulario con estos valores
      // Ejemplo:
      // this.form.patchValue({ cuenta: this.cuenta, nombre: this.nombre });
    });
    this.inicializarBusqueda();
    this.inicializeAspelOptions();
    this.busqueda = this.paginadorService.getBusquedaCatalogo(this.titulo_paginador);
    if(this.busqueda.criteriaSearch['tpol'] == null){
      this.filtroDeBusqueda('0', 'tpol');

    }
      
    if(this.busqueda.criteriaSearch['mes'] == null){
      this.filtroDeBusqueda('0', 'mes');

    }
    if(this.busqueda.criteriaSearch['estatus'] == null){
      this.filtroDeBusqueda('2', 'estatus');

    }
    if(this.busqueda.criteriaSearch['concepto_pa'] == null){
      this.filtroDeBusqueda('', 'concepto_pa');

    }
    this.busqueda.page1 = true;
    this.filtro_navegacion = false;
    this.cargarCatalogo();
    this.cargarTiposPolizas();
    this.cargarDatosPeriodoActual();
    this.fecha_poliza = this.obtenerFechaEnFormatoYYYYMMDD();
  }
relacionarCtbPolAddDoc(add_doc_id:number){
  this.addDocService.postCtbPolAddDoc(this.tmp_index_pol,add_doc_id).subscribe(response => {
    Swal.fire({
      icon: 'success',
      title: 'TNK Ledger',
      text: response.mensaje
    })
  }, err => {
    if (err.error.mensaje == null || '' || undefined) {
      err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
    }
    Swal.fire({
      icon: 'error',
      title: 'TNK Ledger',
      text: err.error.mensaje
    })
    console.log(err);
    this.cargado = true;
  });
}
borrarCtbPolAddDoc(add_doc_id:number){
  this.addDocService.deleteCtbPolAddDoc(this.tmp_index_pol,add_doc_id).subscribe(response => {
    Swal.fire({
      icon: 'success',
      title: 'TNK Ledger',
      text: response.mensaje
    })
    this.cargarAsociados(this.tmp_index_pol);
  }, err => {
    if (err.error.mensaje == null || '' || undefined) {
      err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
    }
    Swal.fire({
      icon: 'error',
      title: 'TNK Ledger',
      text: err.error.mensaje
    })
    console.log(err);
    this.cargado = true;
  });
}
  cargarAsociados(id:number){
    this.tmp_index_pol = id;
    this.addDocService.cargarCfdisAsociadosByPolId(id).subscribe(response => {
      this.documentos_asociados = response.contenido;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
      this.cargado = true;
    });
  }
  descargarPdf(id: number) {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Descargando...',
      timerProgressBar: true,
      showConfirmButton:false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        this.addDocService.getNombreContenidoById(id).subscribe(response => {
          this.elemento.nombre = response.nombre.replace('.xml', '');
          this.elemento.contenido = response.contenido;
          this.addDocService.descargaCfdiPdf(this.elemento).subscribe(response2 => {
            this.cerrarMensajeCarga();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(response2);
            //a.download = response.nombre.replace('.xml', '');
            //document.body.appendChild(a);
            window.open(a.href, 'download_window', 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
            window.focus();
          }, err2 => {
            this.cerrarMensajeCarga();
            if (err2.error.mensaje == null || '' || undefined) {
              err2.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err2.error.mensaje
            });
            console.log(err2);
          });
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          });
          console.log(err);
        });
      }
    });
  }
  setCtbPolId(_ctb_pol_id: number){
    this._ctb_pol_id = _ctb_pol_id;
  }
  generarPolizaReversa(){
    this.polService.ctb_genera_poliza_cancelacion(this.loginService.usuario.id,
       this.loginService.usuario.empresa_seleccionada.id, 
       this._ctb_pol_id, this._ctb_tpol_id, this.fecha_poliza).subscribe(response => {
        Swal.fire({
          icon: 'success',
          title: 'TNK Ledger',
          text: response.mensaje
        });
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
        this.cargado = true;
      });


  }
  obtenerFechaEnFormatoYYYYMMDD(): string {
    const fechaActual = new Date();
    const year = fechaActual.getFullYear();
    const month = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
    const day = fechaActual.getDate().toString().padStart(2, '0');
    const fechaFormateada = `${year}-${month}-${day}`;
    return fechaFormateada;
  }
  inicializeAspelOptions(){

    const currentYear = new Date().getFullYear();
    this.selectedYear = currentYear;
    this.selectedMonth = 0;

    this.updateDaysList();
    this.selectedDay = new Date().getDate();
    for (let year = currentYear; year >= 1900; year--) {
      this.years.push(year);
    }
  }
  updateDaysList() {
    const daysInMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    this.days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  }
  convertDate(date: Date) {
    const yyyy = date.getFullYear().toString();
    const mm = (date.getMonth() + 1).toString();
    const dd = date.getDate().toString();

    const mmChars = mm.split('');
    const ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : '0' + mmChars[0]) + '-' + (ddChars[1] ? dd : '0' + ddChars[0]);
  }
  cargarDatosPeriodoActual() {
    this.polService.getDatosCierre(this.loginService.empresa).subscribe(
      response => {
        this.tipo_cierre = response.contenido.tipo_cierre;
      }
    );
  }
  
  getFormatoAspel(){
    if(this.busqueda.criteriaSearch['tpol_id'] === undefined){
      this.filtroDeBusqueda(0, 'tpol_id')
    }
    this.polService.getFormatoAspel(this.loginService.empresa, this.busqueda.criteriaSearch['tpol_id'] as number, 
    this.selectedYear, this.selectedMonth, this.selectedDay).subscribe(
      response => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(response);
        if(this.selectedDay == 0){
          a.download = 'ASPEL_' + this.selectedYear + '_' + this.months[this.selectedMonth-1] + '_Todos.xls';
        } else {
          a.download = 'ASPEL_' + this.selectedYear + '_' + this.months[this.selectedMonth-1] + '_Día_'+this.selectedDay+'.xls';
        }
        document.body.appendChild(a);
        a.click();
      }
    );

  }
  toogle() {
    if (this.filtro_navegacion == true) {
      this.busqueda.criteriaSearch = {};
      this.filtro_navegacion = false;
    } else {
      this.filtro_navegacion = true;
    }
    this.cargarCatalogo();
  }
  cargarTiposPolizas() {
    this.polService.tpolGet(this.loginService.empresa).subscribe(response => {
      this.tpolList = response;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  cargarCatalogo() {
    this.cargado = false;
    if (this.filtro_navegacion == true) {
      this.busqueda.criteriaSearch['mes'] = this.periodo_vigente;
    } 
    this.busqueda.criteriaSearch['ano'] = this.ejercicio_seleccionado;
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;

    if(this.folio != null && this.fecha != null && this.concepto != null){
      this.busqueda.criteriaSearch['folio'] = this.folio;
      this.busqueda.criteriaSearch['fecha'] = this.fecha;
      this.busqueda.criteriaSearch['concepto'] = this.concepto;
    }
    if(this.id != null){
      this.busqueda.criteriaSearch['id'] = this.id;
    }
     if(this.inicio != null && this.fin != null){
      this.busqueda.criteriaSearch['inicio'] = this.inicio;
      this.busqueda.criteriaSearch['fin'] = this.fin;
this.busqueda.criteriaSearch['mes'] = 0;
     }
  
    
    this.polService.polCatalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      if(this.folio != null && this.fecha != null && this.concepto != null){
        if (this.items.length === 1) {
          this.router.navigate(['/contabilidad/proceso/ctb-pol/actualizar', this.items[0].id], { queryParams: { sinMenu: true }});
        }}
        if(this.id != null){
        if (this.items.length === 1) {
          this.router.navigate(['/contabilidad/proceso/ctb-pol/actualizar', this.items[0].id], { queryParams: { sinMenu: true }});
        }}
      this.totalItems = response.contenido.totalElements;
      this.cargado = true;
      this.paginadorService.setBusquedaCatalogo(this.titulo_paginador,this.busqueda);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
      this.cargado = true;
    });
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page;
    this.cargarCatalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 1;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }
  limpiarBusqueda(): void {
    this.busqueda.sort = false;
    this.busqueda.criteriaSearch = {};
    this.busqueda.pageNumber = 1;
    
    this.filtroDeBusqueda(false, 'poliza_ajuste');
    this.filtroDeBusqueda('', 'concepto_pa');
    this.filtroDeBusqueda('0', 'tpol');
    this.filtroDeBusqueda('0', 'mes');
    this.filtroDeBusqueda('2', 'estatus');
    this.cargarCatalogo();
  }
  eliminar(dtoEliminar: any): void {
    Swal.fire({
      title: '¿Está seguro de cancelar esta póliza?',
      text: `Las relaciones con CFDIS y la DIOT serán afectadas durante esta operación`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.polService.polDelete(dtoEliminar.id, this.loginService.usuario.id as number).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }




  consultarListaNegra(rfc: string, indice: number) {
    if (this.consulta_lista_negra.lista.length === 0 ||
      (this.consulta_lista_negra.lista.length > 0
        && this.consulta_lista_negra.lista[0].rfc !== rfc)
    ) {
      Swal.fire({
        title: 'TNK Ledger',
        html: 'Verificando...',
        timerProgressBar: true,
        showConfirmButton:false,
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
          this.listaNegraService.consultarEstatusRfc(rfc).subscribe(
            response => {
              Swal.close();
              this.consulta_lista_negra = response.contenido;
              if (this.consulta_lista_negra.lista.length === 0) {
                this.itemsAddDoc[indice].estatus_verificado = 2;
                this.consulta_lista_negra = { campos: [], lista: [] };
              }
              if (this.consulta_lista_negra.lista.length > 0) {
                if (this.verificarSentenciaFavorable(this.consulta_lista_negra.lista) === false) {
                  this.itemsAddDoc[indice].estatus_verificado = 3;
                } else {
                  this.itemsAddDoc[indice].estatus_verificado = 2;
                  this.consulta_lista_negra = { campos: [], lista: [] };
                }
              }
            }, err => {
              if (err.error.mensaje == null || '' || undefined) {
                err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
              }
              Swal.close();
              Swal.fire({
                icon: 'error',
                title: 'TNK Ledger',
                text: err.error.mensaje
              });
            });
        }
      });

    }
  }
  verificarSentenciaFavorable(lista: any[]): boolean {
    for (let x = 0; x < lista.length; x++) {
      if (lista[x].situacion_del_contribuyente !== 'Sentencia Favorable') {
        return false;
      }
    }
    return true;
  }







    getCtbPolConf() {
    
    this.polService.getCtbPolConf(this.loginService.empresa).subscribe(response => {
      this.ctb_pol_conf= response.contenido;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
}
